module.exports = __webpack_public_path__ + "img/Step04b.7235de05.webp";